module.exports = __webpack_public_path__ + "static/media/GeneralProposal.47d364bf.pdf";